import { render, staticRenderFns } from "./PageDefault.vue?vue&type=template&id=252098b9&scoped=true&"
import script from "./PageDefault.vue?vue&type=script&lang=js&"
export * from "./PageDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252098b9",
  null
  
)

export default component.exports